import { formatCurrency } from "@/helpers/currency-helpers";
import { IRenewTotal } from "@/interfaces/renew.interfaces";

type Return = Partial<IRenewTotal> & {
  formattedTotalCustomerSalesProduct: string;
  formattedTotalEventValue: string;
  formattedTotalPaid: string;
};

type Props = {
  renew: IRenewTotal | null;
};

function useRenewTotalData({ renew }: Props): Return {
  const formattedTotalCustomerSalesProduct = formatCurrency(
    Number(renew?.totalCustomerSalesProduct) || 0
  );
  const formattedTotalEventValue = formatCurrency(Number(renew?.totalEventValue) || 0);
  const formattedTotalPaid = formatCurrency(Number(renew?.totalPaid) || 0);

  return {
    ...renew,
    formattedTotalCustomerSalesProduct,
    formattedTotalEventValue,
    formattedTotalPaid,
  };
}

export default useRenewTotalData;
